import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChartBar, FaBullseye, FaUsers, FaHandshake, FaUserTie, FaBuilding, FaFlask, FaUniversity, FaQuestionCircle, FaPlus, FaMinus, FaChalkboardTeacher, FaBalanceScale, FaLink, FaFileContract, FaExchangeAlt, FaUserGraduate } from 'react-icons/fa';
import { FiTarget, FiCopy } from 'react-icons/fi';
import { HiOutlineAcademicCap, HiOutlineOfficeBuilding, HiOutlineGlobeAlt } from 'react-icons/hi';
import PageTemplate from '../../components/Common/PageTemplate';
import './Statistics.css';

const Statistics = () => {

  const [activeSection, setActiveSection] = useState('aims');

  const facultyData = [
    { name: "Duru Karasoy", title: "Prof. Dr.", sub_department: "Uygulamalı İstatistik", avesis_url: "https://avesis.hacettepe.edu.tr/duru", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5920" },
    { name: "Duygu İçen", title: "Doç. Dr.", sub_department: "Uygulamalı İstatistik", avesis_url: "https://avesis.hacettepe.edu.tr/duyguicn", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7293" },
    { name: "Nilgün Özgül", title: "Doç. Dr.", sub_department: "Uygulamalı İstatistik", avesis_url: "https://avesis.hacettepe.edu.tr/nozgul", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5532" },
    { name: "Hatice Öncel Çekim", title: "Doç. Dr.", sub_department: "Uygulamalı İstatistik", avesis_url: "https://avesis.hacettepe.edu.tr/oncelhatice", photo_url: "https://avesis.hacettepe.edu.tr/user/image/8526" },
    { name: "Nursel Koyuncu", title: "Prof. Dr.", sub_department: "İstatistik Teorisi", avesis_url: "https://avesis.hacettepe.edu.tr/nkoyuncu", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6932" },
    { name: "Yasemin Kayhan Atılgan", title: "Doç. Dr.", sub_department: "İstatistik Teorisi", avesis_url: "https://avesis.hacettepe.edu.tr/ykayhan", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6471" },
    { name: "Özge Karadağ Ataş", title: "Doç. Dr.", sub_department: "İstatistik Teorisi", avesis_url: "https://avesis.hacettepe.edu.tr/ozgekaradag", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6271" },
    { name: "Onur Toka", title: "Dr. Öğr. Üyesi", sub_department: "İstatistik Teorisi", avesis_url: "https://avesis.hacettepe.edu.tr/onur.toka", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7207" },
    { name: "Cem Kadılar", title: "Prof. Dr.", sub_department: "Yöneylem Araştırması", avesis_url: "https://avesis.hacettepe.edu.tr/kadilar", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6381" },
    { name: "Çağdaş Hakan Aladağ", title: "Prof. Dr.", sub_department: "Yöneylem Araştırması", avesis_url: "https://avesis.hacettepe.edu.tr/aladag", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6580" },
    { name: "Esra Polat", title: "Doç. Dr.", sub_department: "Yöneylem Araştırması", avesis_url: "https://avesis.hacettepe.edu.tr/espolat", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6540" },
    { name: "Meral Çetin", title: "Prof. Dr.", sub_department: "Risk Analizi", avesis_url: "https://avesis.hacettepe.edu.tr/meral", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5438" },
    { name: "Ayten Yiğiter", title: "Doç. Dr.", sub_department: "Risk Analizi", avesis_url: "https://avesis.hacettepe.edu.tr/yigiter", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6247" },
    { name: "Melike Bahçecitapar", title: "Doç. Dr.", sub_department: "Risk Analizi", avesis_url: "https://avesis.hacettepe.edu.tr/mlk", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6497" },
    { name: "Derya Ersel", title: "Doç. Dr.", sub_department: "Risk Analizi", avesis_url: "https://avesis.hacettepe.edu.tr/dtektas", photo_url: "https://avesis.hacettepe.edu.tr/user/image/8069" },
    { name: "İbrahim Zor", title: "Dr. Öğr. Üyesi", sub_department: "Risk Analizi", avesis_url: "https://avesis.hacettepe.edu.tr/ibrahimz", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5735" },
    { name: "Özgür Yeniay", title: "Prof. Dr.", sub_department: "Olasılık Teorisi ve Olasılık Süreçleri", avesis_url: "https://avesis.hacettepe.edu.tr/yeniay", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5460" },
    { name: "Serpil Aktaş Altunay", title: "Prof. Dr.", sub_department: "Olasılık Teorisi ve Olasılık Süreçleri", avesis_url: "https://avesis.hacettepe.edu.tr/spxl", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5515" },
    { name: "Ayfer Ezgi Yılmaz Çakıroğlu", title: "Doç. Dr.", sub_department: "Olasılık Teorisi ve Olasılık Süreçleri", avesis_url: "https://avesis.hacettepe.edu.tr/ezgiyilmaz", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6296" },
    { name: "Ceren Eda Can", title: "Dr. Öğr. Üyesi", sub_department: "Olasılık Teorisi ve Olasılık Süreçleri", avesis_url: "https://avesis.hacettepe.edu.tr/cerencan", photo_url: "https://avesis.hacettepe.edu.tr/user/image/100067" },
    { name: "Sevil Bacanlı", title: "Prof. Dr.", sub_department: "İstatistiksel Bilgi Sistemleri", avesis_url: "https://avesis.hacettepe.edu.tr/sevil", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5981" },
    { name: "Gamze Özel Kadılar", title: "Prof. Dr.", sub_department: "İstatistiksel Bilgi Sistemleri", avesis_url: "https://avesis.hacettepe.edu.tr/gamzeozl", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5453" },
    { name: "Nihal Ata Tutkun", title: "Prof. Dr.", sub_department: "İstatistiksel Bilgi Sistemleri", avesis_url: "https://avesis.hacettepe.edu.tr/nihalata", photo_url: "https://avesis.hacettepe.edu.tr/user/image/8280" },
    { name: "Semra Türkan", title: "Doç. Dr.", sub_department: "İstatistiksel Bilgi Sistemleri", avesis_url: "https://avesis.hacettepe.edu.tr/sturkan", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6992" }
  ];

  const classroomsData = [
    { name: "Derslik 1", img: "https://debi.hacettepe.edu.tr/dosya/XdI3kOeverLGMji0kcAVEcfykDSDl2XEwCd5q5Xh.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/743" },
    { name: "Derslik 2", img: "https://debi.hacettepe.edu.tr/dosya/vTgut00n0aRizhGmjdadvH10uficubtZnRUAdu0G.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/744" },
    { name: "Derslik 3", img: "https://debi.hacettepe.edu.tr/dosya/NkQvBU1OqfFzqM1ZvdRLgRyUBHzVMYTx5c3uHP4k.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/745" },
    { name: "Derslik 4", img: "https://debi.hacettepe.edu.tr/dosya/ZvNqzo3uvQmm2IZiLFLAwfwGZudEzTO4LNg2vERg.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/751" },
    { name: "Derslik 5", img: "https://debi.hacettepe.edu.tr/dosya/HuYA2JUO4UHjmBkjb8r8B9hcVzPlGGdDnhT88lfy.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/752" },
    { name: "Derslik 6", img: "https://debi.hacettepe.edu.tr/dosya/tQqxvKprtAXdtBSpSan83vrlyUsnXLnCGhC8oNaN.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/753" },
    { name: "Derslik 7", img: "https://debi.hacettepe.edu.tr/dosya/mNn5yNPIguUhfpmQkyUTVMdSngjfQVqP1IiUKPnW.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/754" },
    { name: "İstatistik Bilgisayar Laboratuvarı", img: "https://debi.hacettepe.edu.tr/dosya/XMa3vjhmTzaWbqdWl2C47rE9TqDktcN3LNX9nkdm.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/762" },
    { name: "Derslik 8", img: "https://debi.hacettepe.edu.tr/dosya/jgGGSQEEMyoUdncKgl5OAz43q5QfxC52pCTnCI60.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/765" },
    { name: "Laboratuvar 1", img: "https://debi.hacettepe.edu.tr/dosya/6C7KLp3vM6FDWdZyGdkjSjR7HA1RgjvpdXCoUUcN.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/767" },
    { name: "Laboratuvar 2", img: "https://debi.hacettepe.edu.tr/dosya/Y439h41U34yLB7UovLOJAHb1Rya0zbZw6qfDDjeK.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/769" },
    { name: "Laboratuvar 3", img: "https://debi.hacettepe.edu.tr/dosya/tE0mBZVqHIBWi89Rpol851ZsuKTtjxv393mJWBet.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/771" },
    { name: "Laboratuvar 4", img: "https://debi.hacettepe.edu.tr/dosya/gA29r0YQ2nfpT9ohrOAbM20Di6UdwG0rigUwOQ9q.jpg", link: "https://debi.hacettepe.edu.tr/derslik/detay/773" },
  ];

  const faqData = [
    {
      question: "Bir yarıyılda en fazla kaç AKTS kredi alabilirim?",
      answer: "Öğrenciler dört yıllık programlarda birinci, ikinci, üçüncü ve dördüncü yarıyıllarda en fazla 30 AKTS kredili, beşinci yarıyıldan itibaren en fazla 40 AKTS kredili ders alabilirler. Öğrencilerin başka üniversitelerden aldıkları dersler de bu sınırlamaların içindedir."
    },
    {
      question: "Bölümü en fazla kaç yılda tamamlamalıyım?",
      answer: "Öğrenciler bir yıl süreli yabancı dil hazırlık sınıfı hariç, her yarıyıl için kayıt yaptırıp yaptırmadığına bakılmaksızın lisans programlarını azami yedi yılda tamamlamak zorundadırlar."
    },
    {
      question: "Mezun olabilmek için hangi dersleri tamamlamak durumundayım?",
      answer: "Öğrencilerin UNİ 101 dersi ve ortak zorunlu dersleri, alan içi zorunlu dersleri, alan içi (İST kodlu seçmeli dersler ve istatistik bölümüne açılan AKT385 ve AKT476 dersleri) ve alan dışı seçmeli dersleri başarı ile tamamlaması gerekir."
    },
    {
      question: "Ortak Zorunlu dersler hangileridir?",
      answer: "Türk Dili (TKD103, TKD104), Atatürk İlkeleri ve İnkılap Tarihi (AİT203, AİT204), Temel Bilgi ve İletişim Teknolojileri Kullanımı (BEB650) dersleri tüm yükseköğretim programlarında yer alan ortak zorunlu derslerdir."
    },
    {
        question: "Zorunlu dersler arasında yer alan ING127, ING128, ING237 ve ING238 dersleri nedir? Bu derslerden muaf olabilir miyim?",
        answer: "ING kodlu zorunlu dersler, öğrencilerin temel düzeyde İngilizce dil becerilerini geliştirmesini amaçlayan derslerdir. Yabancı Diller Yüksekokulu (YDYO) Modern Diller Birimi tarafından verilmektedir. Her ders için her yarıyıl başında muafiyet sınavları olmaktadır. Önkoşul, muafiyet, ders geçme notu gibi detaylar için <a href='//www.ydyo.hacettepe.edu.tr/' target='_blank' rel='noopener noreferrer'>www.ydyo.hacettepe.edu.tr</a> adresini ziyaret edebilirsiniz."
    },
    {
        question: "Alan içi ve alan dışı seçmeli dersler ne anlama gelmektedir?",
        answer: `<b>a) Alan içi seçmeli dersler</b>, öğrencinin kayıtlı olduğu öğretim programlarında yer alan ve mezun olabilmesi için önerilen belirli dersler veya ders grupları arasından seçerek alacağı İST kodlu dersler ile İstatistik Bölümü'ne açılan "AKT385 Aktüerya" ve "AKT476 Risk Yönetimi ve Sigortacılık" dersleridir. Alan içi seçmeli dersler, İstatistik Bölümü lisans öğretim programında S ile belirtilmiştir.<br/><br/><b>b) Alan dışı seçmeli dersler</b>, öğrencinin kayıtlı olduğu öğretim programında yer almayıp, farklı akademik birimler tarafından açılmış derslerdir. SEC kodlu dersler de, alan dışı seçmeli dersler statüsündedir. Bu dersler, Seçmeli Dersler Birim Koordinatörlüğü tarafından her ilgi ve beceri alanına yönelik olarak açılmaktadır. SEC kodlu derslerle ilgili ayrıntılı bilgi ve duyurular için <a href='//www.secmeli.hacettepe.edu.tr/' target='_blank' rel='noopener noreferrer'>www.secmeli.hacettepe.edu.tr</a> adresini ziyaret edebilirsiniz. SEC kodlu derslerden öğrenim hayatı boyunca en fazla 3 tane alınabilmektedir.`
    },
    {
        question: "Mezun olabilmek için kaç AKTS kredisini tamamlamam gerekir?",
        answer: `İstatistik Bölümünden mezun olabilmek için öğrencilerin toplamda 240 AKTS kredi kazanmaları gerekmektedir. Mezuniyet için gerekli olan kredilerin dağılımları aşağıdaki tabloda verilmiştir.<br/><br/>
        <table class='faq-table'>
            <thead>
                <tr>
                    <th>Giriş Yılı</th>
                    <th>Zorunlu Dersler</th>
                    <th>Alan İçi Seçmeli</th>
                    <th>Alan Dışı Seçmeli</th>
                    <th>Ortak Zorunlu + UNI101</th>
                    <th>Toplam</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>2018 öncesi</td>
                    <td>138 AKTS</td>
                    <td>En az 67 AKTS</td>
                    <td>En az 8 AKTS</td>
                    <td>11 AKTS</td>
                    <td>En az 240 AKTS</td>
                </tr>
                <tr>
                    <td>2018 – 2021</td>
                    <td>133 AKTS</td>
                    <td>En az 72 AKTS</td>
                    <td>En az 8 AKTS</td>
                    <td>11 AKTS</td>
                    <td>En az 240 AKTS</td>
                </tr>
                <tr>
                    <td>2022 ve sonrası</td>
                    <td>139 AKTS</td>
                    <td>En az 66 AKTS</td>
                    <td>En az 8 AKTS</td>
                    <td>11 AKTS</td>
                    <td>En az 240 AKTS</td>
                </tr>
            </tbody>
        </table>`
    },
    {
        question: "Bölüme devam zorunluluğu var mıdır?",
        answer: "Derslere ve uygulamalara devam zorunludur. Mazeretler de dahil olmak üzere kuramsal (Teorik) saatlerin %30'undan, uygulama saatlerinin de %20'sinden fazlasına katılmayan öğrenci o dersin genel sınavına ve bütünleme sınavına alınmaz ve öğrenciye F1 notu verilir."
    }
  ];

  return (
    <PageTemplate 
      title="İstatistik Bölümü"
      subtitle="Verinin gücünü keşfedin, geleceği şekillendirin."
    >
      <div className="stats-nav-container">
        <nav className="stats-nav">
          <button onClick={() => setActiveSection('aims')} className={activeSection === 'aims' ? 'active' : ''}>Amaç ve Hedefler</button>
          <button onClick={() => setActiveSection('education')} className={activeSection === 'education' ? 'active' : ''}>Öğretim Amaçları</button>
          <button onClick={() => setActiveSection('faculty')} className={activeSection === 'faculty' ? 'active' : ''}>Akademik Kadro</button>
          <button onClick={() => setActiveSection('classrooms')} className={activeSection === 'classrooms' ? 'active' : ''}>Derslikler</button>
          <button onClick={() => setActiveSection('programs')} className={activeSection === 'programs' ? 'active' : ''}>Yan Dal & ÇAP</button>
          <button onClick={() => setActiveSection('exchange')} className={activeSection === 'exchange' ? 'active' : ''}>Değişim Programları</button>
          <button onClick={() => setActiveSection('graduate')} className={activeSection === 'graduate' ? 'active' : ''}>Lisansüstü</button>
          <button onClick={() => setActiveSection('stakeholders')} className={activeSection === 'stakeholders' ? 'active' : ''}>Paydaşlarımız</button>
          <button onClick={() => setActiveSection('management')} className={activeSection === 'management' ? 'active' : ''}>Yönetim</button>
          <button onClick={() => setActiveSection('faq')} className={activeSection === 'faq' ? 'active' : ''}>S.S.S.</button>
        </nav>
      </div>

      <div className="stats-content">
        {activeSection === 'aims' && <AimsSection />}
        {activeSection === 'education' && <EducationAimsSection />}
        {activeSection === 'faculty' && <FacultySection facultyData={facultyData} />}
        {activeSection === 'classrooms' && <ClassroomsSection classroomsData={classroomsData} />}
        {activeSection === 'programs' && <ProgramsSection />}
        {activeSection === 'exchange' && <ExchangeProgramsSection />}
        {activeSection === 'graduate' && <GraduateProgramsSection />}
        {activeSection === 'stakeholders' && <StakeholdersSection />}
        {activeSection === 'management' && <ManagementSection />}
        {activeSection === 'faq' && <FAQSection faqData={faqData} />}
      </div>
    </PageTemplate>
  );
};

const AimsSection = () => (
  <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ staggerChildren: 0.2 }}>
    <h2 className="stats-section-title">Amaçlar ve Hedefler</h2>
    <div className="aims-grid">
      <motion.div className="aim-card" variants={{ hidden: { y: 20, opacity: 0 }, show: { y: 0, opacity: 1 } }}>
        <h3>Temel Amaçlar</h3>
        <ul>
          <li>Matematiksel temellere dayanan istatistik kuram ve yöntemlerini öğretmek.</li>
          <li>Yöneylem Araştırması, Risk Analizleri, Aktüerya gibi teknik alanlarda bilgi birikimi sağlamak.</li>
          <li>Farklı disiplinlerdeki uygulamalara yönelik bilimsel çözümler geliştirme yetkinliği kazandırmak.</li>
          <li>Akademik kariyer hedefleyenler için sağlam bir temel oluşturmak.</li>
        </ul>
      </motion.div>
      <motion.div className="aim-card" variants={{ hidden: { y: 20, opacity: 0 }, show: { y: 0, opacity: 1 } }}>
        <h3>Diğer Amaçlar</h3>
        <ul>
          <li>Eğitim ve öğretim programlarının kalitesini artırmak.</li>
          <li>Bilimsel araştırmaları nitelik ve nicelik yönünden geliştirmek.</li>
          <li>Paydaş memnuniyetini artırmak ve dış ilişkileri güçlendirmek.</li>
          <li>Modern eğitim yöntemlerini benimsemek.</li>
          <li>Ulusal ve uluslararası tanınırlığı artırmak.</li>
        </ul>
      </motion.div>
    </div>
  </motion.div>
);

const EducationAimsSection = () => (
    <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ staggerChildren: 0.2 }}>
        <h2 className="stats-section-title">Öğretim Amaçları</h2>
        <div className="edu-aims-container">
            {[
                "İstatistik alanında araştırmacı ve eğitim elemanı olarak yetişmek isteyen öğrencilerimize sağlam bir temel hazırlama.",
                "Yöneylem Araştırması, Risk Analizleri, Aktüerya Bilimleri gibi alanlarda da araştırma yapabilmek.",
                "İstatistik biliminin farklı disiplinlerle ilişkisini geliştirecek bilgi birikimini sağlamak.",
                "Veri madenciliği ve büyük veri kavramlarına hâkim, bilişim teknolojilerini etkili kullanabilen nitelikli istatistikçiler yetiştirmek."
            ].map((aim, index) => (
                <motion.div key={index} className="edu-aim-card" variants={{ hidden: { y: 20, opacity: 0 }, show: { y: 0, opacity: 1 } }}>
                    <FiTarget className="edu-aim-icon" />
                    <p>{aim}</p>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const FacultySection = ({ facultyData }) => {
    const [selectedSubDepartment, setSelectedSubDepartment] = useState('Tümü');
    const subDepartments = ['Tümü', ...new Set(facultyData.map(f => f.sub_department))];
    const filteredFaculty = facultyData.filter(f => selectedSubDepartment === 'Tümü' || f.sub_department === selectedSubDepartment);

    return (
        <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
            <h2 className="stats-section-title">Akademik Kadro</h2>
            <div className="faculty-filter-container">
                {subDepartments.map(dept => (
                    <button key={dept} onClick={() => setSelectedSubDepartment(dept)} className={selectedSubDepartment === dept ? 'active' : ''}>
                        {dept}
                    </button>
                ))}
            </div>
            <div className="faculty-grid-stats">
                {filteredFaculty.map((member, index) => (
                    <motion.div key={index} className="faculty-card-stats"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: index * 0.05 }}
                    >
                        <img src={member.photo_url || 'default-avatar.png'} alt={member.name} onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${member.name.replace(" ", "+")}&background=0D47A1&color=fff`; }} />
                        <div className="faculty-info-stats">
                            <h3>{member.name}</h3>
                            <p>{member.title}</p>
                            <span>{member.sub_department}</span>
                            <a href={member.avesis_url} target="_blank" rel="noopener noreferrer">AVESİS Profili</a>
                        </div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

const StakeholdersSection = () => (
  <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
    <h2 className="stats-section-title">Paydaşlarımız</h2>
    <div className="stakeholders-container">
      <motion.div className="stakeholder-card" variants={{ hidden: { x: -20, opacity: 0 }, show: { x: 0, opacity: 1 } }}>
        <h3><FaUniversity /> İç Paydaşlar</h3>
        <ul>
          <li>Öğrenciler</li>
          <li>Öğretim Üyeleri ve Görevlileri</li>
          <li>Araştırma Görevlileri</li>
          <li>Bölüm İdari Personeli</li>
          <li>Rektörlük ve Dekanlık</li>
          <li>Fen Bilimleri Enstitüsü</li>
        </ul>
      </motion.div>
      <motion.div className="stakeholder-card" variants={{ hidden: { x: 20, opacity: 0 }, show: { x: 0, opacity: 1 } }}>
        <h3><HiOutlineGlobeAlt /> Dış Paydaşlar</h3>
        <ul>
          <li>Mezunlar ve Diğer Üniversiteler</li>
          <li>Kamu Kuruluşları (TÜİK, Bakanlıklar, Merkez Bankası)</li>
          <li>Özel Sektör (Bankalar, Sigorta, Teknoloji, Sağlık)</li>
          <li>Teknokentler ve Uluslararası Kurumlar (BM, AB, OECD)</li>
        </ul>
      </motion.div>
    </div>
  </motion.div>
);

const ManagementSection = () => (
    <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
        <h2 className="stats-section-title">Yönetim</h2>
        <div className="management-container-stats">
            <div className="management-card-stats">
                <h4>Bölüm Başkanı</h4>
                <p>Prof. Dr. Serpil AKTAŞ ALTUNAY</p>
                <span>spxl@hacettepe.edu.tr</span>
            </div>
            <div className="management-card-stats">
                <h4>Bölüm Başkan Yardımcısı</h4>
                <p>Doç. Dr. Hatice ÖNCEL ÇEKİM</p>
                <span>oncelhatice@hacettepe.edu.tr</span>
            </div>
            <div className="management-card-stats">
                <h4>Bölüm Başkan Yardımcısı</h4>
                <p>Doç. Dr. Ayfer Ezgi YILMAZ</p>
                <span>ezgiyilmaz@hacettepe.edu.tr</span>
            </div>
        </div>
    </motion.div>
);

const ClassroomsSection = ({ classroomsData }) => (
    <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
        <h2 className="stats-section-title">Derslikler ve Laboratuvarlar</h2>
        <div className="classrooms-grid-stats">
            {classroomsData.map((classroom, index) => (
                <motion.a 
                    key={index}
                    href={classroom.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="classroom-card-stats"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.05 }}
                    whileHover={{ y: -8, boxShadow: '0 16px 32px rgba(0,0,0,0.15)' }}
                >
                    <div className="classroom-image-stats">
                        <img src={classroom.img} alt={classroom.name} onError={(e) => { e.target.src = 'https://debi.hacettepe.edu.tr/images/img_not_found.svg'; }} />
                    </div>
                    <div className="classroom-info-stats">
                        <h3>{classroom.name}</h3>
                    </div>
                </motion.a>
            ))}
        </div>
    </motion.div>
);

const ProgramsSection = () => {
    const [expanded, setExpanded] = useState('yandal'); // 'yandal' or 'cap'

    const programs = {
        yandal: {
            title: "Yan Dal Programı",
            icon: FiCopy,
            content: (
                <>
                    <div className="program-section">
                        <h4>Koordinatörler</h4>
                        <div className="program-coordinators">
                            <p><strong>Koordinatör:</strong> Prof. Dr. Nihal ATA TUTKUN (Tel: +90 312 297 79 00 / 143, E-posta: nihalata@hacettepe.edu.tr)</p>
                            <p><strong>Yardımcı:</strong> Doç. Dr. Hatice ÖNCEL ÇEKİM (Tel: +90 312 297 79 00 / 132, E-posta: oncelhatice@hacettepe.edu.tr)</p>
                        </div>
                    </div>
                    <div className="program-section">
                        <h4>Anlaşmalı Bölümler</h4>
                        <ul className="program-list">
                            <li>Aktüerya Bilimleri</li>
                            <li>Bilgisayar Mühendisliği</li>
                            <li>Endüstri Mühendisliği</li>
                            <li>Matematik</li>
                            <li>Biyoloji</li>
                        </ul>
                    </div>
                    <div className="program-section">
                        <h4>Başvuru Koşulları</h4>
                        <ul className="program-conditions">
                            <li>Anadal lisans programının en erken 3., en geç 6. yarıyılı başında başvuru.</li>
                            <li>Başvurulan yarıyıla kadar tüm anadal derslerini başarıyla tamamlamış olmak.</li>
                            <li>Genel akademik ortalamanın en az 2.75 olması.</li>
                            <li>Başka bir yan dal programına kayıtlı olmamak.</li>
                        </ul>
                    </div>
                    <div className="program-section">
                        <h4>Yönergeler</h4>
                        <p>Hacettepe Üniversitesi Yandal Yönergesi ile ilgili tüm bilgilere yönergeden ulaşabilirsiniz. Başvuru yapacak öğrencilerimizin yönergeyi dikkatlice okumaları faydalı olacaktır.</p>
                        <div className="program-directives">
                            <a href="https://stat.hacettepe.edu.tr/Yandal/2018_Aktuerya_Yandal.pdf" target="_blank" rel="noopener noreferrer">Aktüerya Bilimleri</a>
                            <a href="https://stat.hacettepe.edu.tr/Yandal/2018_Biyoloji_Yandal.pdf" target="_blank" rel="noopener noreferrer">Biyoloji</a>
                            <a href="https://stat.hacettepe.edu.tr/Yandal/2018_Bilgisayar_Muhendisligi_Yandal.pdf" target="_blank" rel="noopener noreferrer">Bilgisayar Müh.</a>
                            <a href="https://stat.hacettepe.edu.tr/Yandal/2018_Endustri_Muhendisligi_Yandal.pdf" target="_blank" rel="noopener noreferrer">Endüstri Müh.</a>
                            <a href="https://stat.hacettepe.edu.tr/Yandal/2018_Matematik_Yandal.pdf" target="_blank" rel="noopener noreferrer">Matematik</a>
                        </div>
                    </div>
                </>
            )
        },
        cap: {
            title: "Çift Anadal Programı (ÇAP)",
            icon: FaBalanceScale,
            content: (
                <>
                    <div className="program-section">
                        <h4>Koordinatörler</h4>
                        <div className="program-coordinators">
                             <p><strong>Koordinatör:</strong> Doç. Dr. Ayten YİĞİTER (Tel: +90 312 297 79 00 / 115, e-posta: yigiter@hacettepe.edu.tr)</p>
                             <p><strong>Yardımcı:</strong> Doç. Dr. Melike BAHÇECİTAPAR (Tel: +90 312 297 79 00 / 126, e-posta: mlk@hacettepe.edu.tr)</p>
                        </div>
                    </div>
                    <div className="program-section">
                        <h4>Anlaşmalı Bölümler</h4>
                        <ul className="program-list">
                            <li>Aktüerya Bilimleri</li>
                            <li>Biyoloji</li>
                            <li>Matematik</li>
                        </ul>
                    </div>
                    <div className="program-section">
                        <h4>Başvuru Koşulları</h4>
                        <ul className="program-conditions">
                            <li>Anadal lisans programının en erken 3., en geç 5. yarıyıl başında başvuru.</li>
                            <li>Tüm anadal derslerini almış ve başarıyla tamamlamış olmak.</li>
                            <li>Genel akademik ortalamanın en az 2.75 olması.</li>
                            <li>Anadal programında sınıfın başarı sıralamasında en üst %20'lik dilimde yer almak.</li>
                        </ul>
                    </div>
                    <div className="program-section">
                        <h4>Yönergeler ve Dilekçe</h4>
                        <div className="program-directives">
                            <a href="https://stat.hacettepe.edu.tr/cap.shtml" target="_blank" rel="noopener noreferrer">Program Yönergeleri</a>
                            <a href="https://stat.hacettepe.edu.tr/dilekce.pdf" target="_blank" rel="noopener noreferrer">Örnek Dilekçe</a>
                        </div>
                    </div>
                </>
            )
        }
    };

    return (
        <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
            <h2 className="stats-section-title">Yan Dal & Çift Anadal Programları</h2>
            <div className="programs-container-accordion">
                {Object.keys(programs).map(key => {
                    const program = programs[key];
                    const isExpanded = expanded === key;
                    return (
                        <div className="program-accordion-item" key={key}>
                            <button className={`program-accordion-header ${isExpanded ? 'expanded' : ''}`} onClick={() => setExpanded(isExpanded ? null : key)}>
                                <div className="program-header-title">
                                    <program.icon className="program-icon" />
                                    <h3>{program.title}</h3>
                                </div>
                                <div className="program-accordion-icon">
                                    {isExpanded ? <FaMinus /> : <FaPlus />}
                                </div>
                            </button>
                            <AnimatePresence>
                                {isExpanded && (
                                    <motion.div
                                        initial="collapsed"
                                        animate="open"
                                        exit="collapsed"
                                        variants={{
                                            open: { opacity: 1, height: 'auto', marginTop: '1.5rem' },
                                            collapsed: { opacity: 0, height: 0, marginTop: 0 }
                                        }}
                                        transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                                    >
                                        <div className="program-accordion-content">
                                            {program.content}
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    );
                })}
            </div>
        </motion.div>
    );
};

const ExchangeProgramsSection = () => {
    const [activeProgram, setActiveProgram] = useState('erasmus_study');

    const programs = {
        erasmus_study: {
            title: 'Erasmus+ Öğrenim',
            content: (
                <div>
                    <h4>Koordinatörler</h4>
                    <div className="coordinators-grid">
                        <p><strong>Koordinatör:</strong> Dr. Öğr. Üyesi Ceren Eda Can</p>
                        <p><strong>Yardımcı:</strong> Arş. Gör. Serhan TUNÇEL</p>
                    </div>
                    <h4>İkili Anlaşmamız Olan Üniversiteler</h4>
                    <img src="https://fs.hacettepe.edu.tr/stat/dosyalar/Screenshot%202023-07-26%20at%202.22.24%20PM.png" alt="Anlaşmalı Üniversiteler" className="program-image" />
                    <h4>İlgili Bağlantılar</h4>
                    <div className="program-links">
                        <a href="#">Erasmus Broşürü</a>
                        <a href="#">ERASMUS+ ile ilgili Bilgiler</a>
                    </div>
                </div>
            )
        },
        erasmus_internship: {
            title: 'Erasmus+ Staj',
            content: (
                <div>
                    <h4>Koordinatörler</h4>
                    <div className="coordinators-grid">
                        <p><strong>Koordinatör:</strong> Prof. Dr. Nihal ATA TUTKUN</p>
                        <p><strong>Yardımcı:</strong> Arş. Gör. Leyla Bakacak Karabenli</p>
                    </div>
                    <h4>Başvuru Kriterleri</h4>
                    <ul className="program-conditions">
                        <li>Tam zamanlı öğrenci olmak.</li>
                        <li>Toplam hareketlilik süresinin 12 ayı geçmemesi.</li>
                        <li>Genel akademik ortalama: Lisans için en az 2.20, Yüksek Lisans/Doktora için 2.50.</li>
                        <li>AB Koordinatörlüğü tarafından ilan edilen yabancı dil puanına sahip olmak.</li>
                    </ul>
                     <h4>İlgili Bağlantılar</h4>
                    <div className="program-links">
                        <a href="http://www.abofisi.hacettepe.edu.tr/tr/ogrencilerin_staj_hareketliligi-21" target="_blank" rel="noopener noreferrer">Öğrenci Staj Hareketliliği</a>
                        <a href="http://www.abofisi.hacettepe.edu.tr/tr/staj_ka_103_giden_ogrenciler_icin_basvuru_sureci-28" target="_blank" rel="noopener noreferrer">KA103 Başvuru Süreci</a>
                        <a href="https://erasmus-plus.ec.europa.eu/programme-guide/part-a/eligible-countries" target="_blank" rel="noopener noreferrer">Program Üyesi Ülkeler</a>
                    </div>
                </div>
            )
        },
        mevlana: {
            title: 'Mevlana',
            content: (
                 <div>
                    <h4>Koordinatörler</h4>
                    <div className="coordinators-grid">
                       <p><strong>Koordinatör:</strong> Doç. Dr. Melike BAHÇECİTAPAR</p>
                       <p><strong>Yardımcı:</strong> Arş. Gör. Dr. Ceren ÜNAL</p>
                    </div>
                    <h4>Program Hakkında</h4>
                    <p>Mevlana Değişim Programı, yurtiçinde ve yurtdışında eğitim veren yükseköğretim kurumları arasında öğrenci ve öğretim elemanı değişimini amaçlayan bir programdır.</p>
                    <h4>Kontenjan Listeleri</h4>
                    <img src="https://fs.hacettepe.edu.tr/stat/dosyalar/mevlana_tr_academics.png" alt="Mevlana Öğretim Üyesi Kontenjanı" className="program-image" />
                    <img src="https://fs.hacettepe.edu.tr/stat/dosyalar/mevlana_tr_students.png" alt="Mevlana Öğrenci Kontenjanı" className="program-image" />
                </div>
            )
        },
        farabi: {
            title: 'Farabi',
            content: (
                <div>
                    <h4>Koordinatörler</h4>
                     <div className="coordinators-grid">
                        <p><strong>Koordinatör:</strong> Prof. Dr. Gamze ÖZEL KADILAR</p>
                        <p><strong>Yardımcı:</strong> Doç. Dr. Nilgün ÖZGÜL ÇELEBİ</p>
                    </div>
                    <h4>İlgili Bağlantılar</h4>
                    <div className="program-links">
                        <a href="#">FARABİ ile ilgili Bilgiler</a>
                        <a href="#">H.Ü. Farabi Koordinatörlüğü</a>
                    </div>
                </div>
            )
        }
    };

    return (
        <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
            <h2 className="stats-section-title">Değişim Programları</h2>
            <div className="exchange-programs-container">
                <div className="exchange-tabs">
                    {Object.keys(programs).map(key => (
                        <button key={key} onClick={() => setActiveProgram(key)} className={activeProgram === key ? 'active' : ''}>
                            {programs[key].title}
                        </button>
                    ))}
                </div>
                <div className="exchange-content">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeProgram}
                            initial={{ y: 10, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -10, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            {programs[activeProgram].content}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </motion.div>
    );
};

const GraduateProgramsSection = () => {
    const [activeProgram, setActiveProgram] = useState('phd');

    const programs = {
        phd: {
            title: 'Doktora',
            content: (
                <div>
                    <h4>Program Hakkında</h4>
                    <p>İstatistik Ana Bilim Dalı Doktora programını tamamlamak için H.Ü Lisansüstü Eğitim Öğretim ve Sınav Yönetmeliği gereği toplam 240 AKTS'yi tamamlamak gereklidir. Bu kredilerin 90 AKTS'si ders, 30 AKTS'si doktora yeterlilik sınavına hazırlık ve 120 AKTS'si ise tezden oluşmaktadır. Dersleri başarı ile tamamlayan ve dörtlük sisteme göre en az 3.00 genel akademik ortalamayı elde etmiş olan öğrenci doktora yeterlilik sınavına girebilir.</p>
                    <h4>Programın Amacı</h4>
                    <p>İstatistiksel problemlerin modellenmesinde ve probleme özgü çözümlerin üretilmesinde yeni yöntem ve stratejiler geliştirebilen, alanında belirli bir konu hakkında detaylı araştırma yapabilme yeteneğine sahip olan ve literatüre katkı yapabilecek düzeyde istatistik teorisine hakim olabilen bireyler yetiştirmeyi amaçlamaktadır.</p>
                    <h4>Mezunların Mesleki Profili</h4>
                    <p>Mezunlar, Üniversiteler, Bankalar, Bakanlıklar, Hazine Müsteşarlığı, Dış Ticaret Müsteşarlığı, Kamu İhale Kurumu, RTÜK, Araştırma şirketleri, AR-GE yapan şirketler, Yazılım şirketleri gibi geniş bir alanda çalışma imkanı bulabilirler.</p>
                    <h4>Program Sorumlusu</h4>
                    <p><strong>Bölüm Başkanı:</strong> Prof. Dr. Serpil Aktaş Altunay<br/><strong>Adres:</strong> Hacettepe Üniversitesi Fen Fakültesi İstatistik Bölümü 06800 Beytepe Ankara<br/><strong>Tel:</strong> 0 (312) 297 79 00<br/><strong>E-posta:</strong> spxl@hacettepe.edu.tr</p>
                    <h4>İlgili Bağlantılar</h4>
                    <div className="program-links">
                        <a href="https://akts.hacettepe.edu.tr/ders_listesi.php?prg_ref=PRGRAM_0000000000000000000000852&birim_kod=2020&submenuheader=2&prg_kod=20202" target="_blank" rel="noopener noreferrer">Ders Listesi</a>
                        <a href="http://www.fenbilimleri.hacettepe.edu.tr/file/yonetmelik/hulisansustuogrvesinavyonetmelik.pdf" target="_blank" rel="noopener noreferrer">Yönetmelik</a>
                    </div>
                </div>
            )
        },
        master: {
            title: 'Tezli Yüksek Lisans',
            content: (
                 <div>
                    <h4>Program Hakkında</h4>
                    <p>İstatistik Ana Bilim Dalı Tezli Yüksek Lisans programını tamamlamak için H.Ü Lisansüstü Eğitim Öğretim ve Sınav Yönetmeliği gereği toplam 120 AKTS'yi tamamlamak gereklidir. Bu kredilerin 60 AKTS'si ders, 60 AKTS'si ise tezden oluşmaktadır.</p>
                    <h4>Programın Amacı</h4>
                    <p>İstatistiksel problemlerin modellenmesinde ve probleme özgü çözümlerin üretilmesinde yeni yöntem ve stratejiler geliştirebilen, alanında belirli bir konu hakkında detaylı araştırma yapabilme yeteneğine sahip olan ve literatüre katkı yapabilecek düzeyde istatistik teorisine hakim olabilen bireyler yetiştirmeyi amaçlamaktadır.</p>
                    <h4>Mezunların Mesleki Profili</h4>
                    <p>Mezunlar hem kamu hem de özel sektör olmak üzere geniş bir alanda iş bulma olanağına sahiptirler. Örneğin, Bankalar, Bakanlıklar, Hazine Müsteşarlığı, Dış Ticaret Müsteşarlığı, Kamu İhale Kurumu, RTÜK, Araştırma şirketleri, AR-GE yapan şirketler, Yazılım şirketleri.</p>
                    <h4>Program Sorumlusu</h4>
                    <p><strong>Bölüm Başkanı:</strong> Prof. Dr.Serpil Aktaş Altunay<br/><strong>Adres:</strong> Hacettepe Üniversitesi Fen Fakültesi İstatistik Bölümü 06800 Beytepe Ankara<br/><strong>Tel:</strong> 0 (312) 297 79 00<br/><strong>E-posta:</strong> spxl@hacettepe.edu.tr</p>
                    <h4>İlgili Bağlantılar</h4>
                    <div className="program-links">
                        <a href="https://akts.hacettepe.edu.tr/ders_listesi.php?prg_ref=PRGRAM_0000000000000000000000538&birim_kod=2020&submenuheader=2&prg_kod=20201" target="_blank" rel="noopener noreferrer">Ders Programı</a>
                    </div>
                </div>
            )
        },
        data_science: {
            title: 'Veri Bilimi (Tezsiz)',
            content: (
                 <div>
                    <h4>Program Hakkında</h4>
                    <p>Veri bilimi yüksek lisans programı, veri analizinin, modellemelerin, tahmin araçlarının, öğrenme süreçlerini uygulayan yöntemleri kullanan her iş alanında uygulama gücü yüksek istatistikçi, veri bilimci ve veri analitikçisi gibi unvanlara sahip bireyler yetiştirmek için oluşturulan uygulamalı bir programdır. Büyük verinin analizinde uygun yöntemleri kullanan donanımlı mezunlar yetiştirmeyi amaçlamaktadır.</p>
                    <h4>Kazanılan Derece Gereklilikleri ve Kurallar</h4>
                    <p>Tezsiz yüksek lisans programı, toplam otuz yerel krediden ve 60 AKTS'den az olmamak kaydıyla en az on ders ile dönem projesi dersinden oluşur.</p>
                    <h4>Mezunların Mesleki Profili</h4>
                    <p>Veri Bilimi tezsiz yüksek lisans programından mezun olanlar veri işleme, değerlendirme, analiz ve tahmin gibi en son teknolojik bilgilere ve kavramlara sahip olup bu bilgileri bilişim teknolojilerinde, sanayide ve endüstride, kamu ve özel sektörde uygun alanlarda uygulayabilecek beceriye ve bilgiye sahip olarak mezun olacaklardır.</p>
                    <h4>Program Sorumlusu</h4>
                    <p><strong>Bölüm Başkanı:</strong> Prof. Dr.Serpil Aktaş Altunay<br/><strong>Adres:</strong> Hacettepe Üniversitesi Fen Fakültesi İstatistik Bölümü 06800 Beytepe Ankara<br/><strong>Tel:</strong> 0 (312) 297 79 00<br/><strong>E-posta:</strong> spxl@hacettepe.edu.tr</p>
                    <h4>İlgili Bağlantılar</h4>
                    <div className="program-links">
                        <a href="https://akts.hacettepe.edu.tr/ders_listesi.php?prg_ref=PRGRAM_0000000000000000000010531&birim_kod=2020&submenuheader=2&prg_kod=45107" target="_blank" rel="noopener noreferrer">Ders Programı</a>
                    </div>
                </div>
            )
        }
    };

    return (
        <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
            <h2 className="stats-section-title">Lisansüstü Programlar</h2>
            <div className="exchange-programs-container">
                <div className="exchange-tabs">
                    {Object.keys(programs).map(key => (
                        <button key={key} onClick={() => setActiveProgram(key)} className={activeProgram === key ? 'active' : ''}>
                            {programs[key].title}
                        </button>
                    ))}
                </div>
                <div className="exchange-content">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeProgram}
                            initial={{ y: 10, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -10, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            {programs[activeProgram].content}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </motion.div>
    );
};

const FAQSection = ({ faqData }) => {
    const [openIndex, setOpenIndex] = useState(0);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    
    return (
        <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
            <h2 className="stats-section-title">Sık Sorulan Sorular</h2>
            <div className="faq-container">
                {faqData.map((item, index) => (
                    <div className="faq-item" key={index}>
                        <button className="faq-question" onClick={() => handleToggle(index)}>
                            <span>{item.question}</span>
                            <div className="faq-icon">
                                {openIndex === index ? <FaMinus /> : <FaPlus />}
                            </div>
                        </button>
                        <AnimatePresence>
                            {openIndex === index && (
                                <motion.div
                                    initial={{ opacity: 0, height: 0, marginTop: 0 }}
                                    animate={{ opacity: 1, height: 'auto', marginTop: '1rem' }}
                                    exit={{ opacity: 0, height: 0, marginTop: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                >
                                    <div className="faq-answer" dangerouslySetInnerHTML={{ __html: item.answer }} />
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                ))}
            </div>
        </motion.div>
    );
};

export default Statistics;
